export class BaseModel<T> {
    toObject(): T {
        return { ...((this as unknown) as T) };
    }
}
